/*
 *
 * File JS per la Homepage
 *
 */

import './general.scss';

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import heroFixedImg from 'components/hero-fixed-img/hero-fixed-img';
import titleBox from 'components/title-box/title-box';
import breadcrumbs from 'components/breadcrumbs/breadcrumbs';
import heroImage from 'imComponents/hero-image/hero-image';
import heroCol from 'components/hero-col/hero-col';
import cmsContent from 'components/cms-content/cms-content';
import boxGallery from 'imComponents/box-gallery/box-gallery';
import carouselGallery from 'imComponents/carousel-gallery/carousel-gallery';
import boxImage from 'components/box-image/box-image';
import listBoxText from 'components/list-box-text/list-box-text';
import listBoxLink from 'components/list-box-link/list-box-link';
import listBoxTextImg from 'components/list-box-text-img/list-box-text-img';
import textOnBg from 'imComponents/text-on-bg/text-on-bg';
import textImgVar from 'imComponents/text-img-var/text-img-var';
import customQuote from 'components/custom-quote/custom-quote';
import sliderNews from 'components/slider-news/slider-news';
import cardNews from 'components/cards/card-news';
import sliderCollection from 'components/slider-collection/slider-collection';
import cardCollection from 'components/cards/card-collection';
import listCardIconText from 'components/list-card-icon-text/list-card-icon-text';
import cardIconText from 'components/cards/card-icon-text';
import boxModules from 'components/box-modules/box-modules';
import colBlockText from 'components/col-block-text/col-block-text';
import contactForm from 'components/contact-form/contact-form';
import cropAnimation from 'animations/crop-animation/crop-animation';
import videoAutoplayOnEnter from 'animations/video-autoplay-onenter/video-autoplay-onenter';
import blockVideo from 'components/block-video/block-video';
import footer from 'components/footer/footer';

//
//--------------------------------------------------------------------//
// INIT COMPONENTI
//--------------------------------------------------------------------//
function initAllComponents() {
    if (!document.querySelector('body.wp-admin')) {
        heroFixedImg();
    }
    boxGallery();
    carouselGallery();
    sliderNews();
    sliderCollection();
    cropAnimation();
    videoAutoplayOnEnter();
}

if (document.querySelector('body.wp-admin')) {
    (function ($) {
        var initBlock = function ($block) {
            initAllComponents();
        };
        if (window.acf) {
            window.acf.addAction('render_block_preview', initBlock);
        }
    })(jQuery);
}

initAllComponents();
//--------------------------------------------------------------------//
